import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const ConditionFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { filters, setFilters } = useContext(TableContext);

  const selectedConditions = filters?.condition;

  function deleteFilter(condition) {
    const newConditionFilter = filters.condition.filter(
      (item) => item !== condition
    );
    setFilters({
      ...filters,
      condition: newConditionFilter,
    });
  }

  return selectedConditions?.map((condition) => (
    <TagChip
      key={condition.code}
      tag={
        <>
          <Typography
            component="span"
            color={theme.palette.colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {`${t('Condition')}: `}
          </Typography>
          <Typography
            component="span"
            color={theme.palette.colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {condition.display}
          </Typography>
        </>
      }
      handleDelete={() => deleteFilter(condition)}
      isCanDelete
      iconColor={theme.palette.colors.blue100}
    />
  ));
};
